module.exports = __webpack_public_path__ + "img/kiosk-carrefour-estrie-home.f994f180.jpg";